module.exports = __webpack_public_path__ + "img/partlysunny.66cc3aa7.png";